import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import {
  cleanMsg,
  CronoResponseItem,
  getTablaCronograma,
  postTablaCronograma,
} from '../../../../../../appStore/cronograma';
import { useConcurso } from '../../../../../../providers/ConcursoProvider';
import { CommonRoot } from '../../../../../CompUtils/CommonRoot';
import Form from '../../../../../CompUtils/Form';
import FullLoading from '../../../../../CompUtils/FullLoading';
import LinkBtn from '../../../../../CompUtils/LinkBtn';
import { SuccessErrorDlg } from '../../../../../CompUtils/SuccessErrorDlg';
import { isLoadingSelector } from '../../../../../GlobalFeedback/feedbackSlice';
import { CronogramaFila } from './CronogramaFila';

const HorizontalDiv = styled.div`
  display: flex;
  flex-direction: row;
`;

const Title = styled.div`
  flex: 1;
`;

const cronogramaConfig = [
  { id: 'inscripWeb', title: 'Inscripción web', time: true },
  { id: 'eval', title: 'Evaluación Inicial' },
  { id: 'antec', title: 'Antecedentes Curriculares' },
  { id: 'evalTec', title: 'Evaluación Técnica General' },
  { id: 'evalTecSustantiva', title: 'Evaluación Técnica Sustantiva' },
  { id: 'evalPsi', title: 'Evaluación Perfil Psicológico' },
  { id: 'ordenMer', title: 'Orden de merito' },
];

type Props = { editable?: boolean };
const TablaCronograma = (props: Props) => {
  const { editable } = props;
  const [isEditing, setIsEditing] = useState(false);
  const concurso = useConcurso();
  const { idLlamadoConcurso } = concurso;
  const initialValues = {
    ['Inscripción web']: {},
    ['Evaluación Inicial']: {},
    ['Antecedentes Curriculares']: {},
    ['Evaluación Técnica General']: {},
    ['Evaluación Técnica Sustantiva']: {},
    ['Evaluación Perfil Psicológico']: {},
    ['Orden de merito']: {},
  };
  const [values, setValues] = useState<any>(initialValues);

  const [save, setSave] = useState(false);
  const [clear, setClear] = useState(false);
  const dispatch = useDispatch();
  const isLoading = useSelector(isLoadingSelector);
  const crono = useSelector((state: any) => state.cronograma);
  const { loading, error, success } = crono;
  /*   const onSubmit = useCallback(
    (valores: Record<string, any>) => {
      const final = Object.keys(valores).reduce<CronoResponseItem[]>((acc, k) => {
        const instancias = k.substr(0, k.indexOf('_'));
        const crono = cronogramaConfig.find((e) => e.id === instancias);

        if (!crono) return acc;
        const f_fin = valores[`${instancias}_f_fin`];
        const f_inicio = valores[`${instancias}_f_inicio`];
        const act = acc.find((e) => e.instancias === crono.title);
        if (act) return acc;
        return [...acc, { instancias: crono.title, f_fin, f_inicio }];
      }, []);

      dispatch(postTablaCronograma({ idLlamadoConcurso, valores: final }));
    },
    [dispatch, idLlamadoConcurso],
  ); */

  const onSubmit = () => {
    setSave(true);
  };

  useEffect(() => {
    if (save && !Object.entries(values).some((a) => !a[1])) {
      const final = Object.keys(values).reduce<CronoResponseItem[]>((acc, k) => {
        const crono = cronogramaConfig.find((e) => e.title === k);
        if (!crono) return acc;
        const act = acc.find((e) => e.instancias === crono.title);
        if (act) return acc;
        return [...acc, { instancias: k, f_fin: values[k].fFin, f_inicio: values[k].fInicio }];
      }, []);
      dispatch(postTablaCronograma({ idLlamadoConcurso, valores: final }));
    }
    setSave(false);
  }, [values]);

  useEffect(() => {
    dispatch(getTablaCronograma({ idLlamadoConcurso }));
  }, [idLlamadoConcurso, dispatch]);

  const onClear = () => {
    setValues(initialValues);
    setClear(true);
  };

  return (
    <CommonRoot>
      <FullLoading show={loading && isLoading < 1} />
      <HorizontalDiv>
        <Title>
          <h2 className="text-info text-center ">CONFECCIÓN DE CRONOGRAMA</h2>
          <p className="h5 d-flex d-flex justify-content-center align-items-center">
            Seleccione las etapas a incluir, y elija una la fecha tentativa para cada una.
          </p>
        </Title>
        {editable && (
          <div>
            <LinkBtn transparent onClick={() => setIsEditing((e) => !e)}>
              <i className="fa fa-2x fa-edit"></i>
            </LinkBtn>
          </div>
        )}
      </HorizontalDiv>
      <Form
        onClear={onClear}
        submitText="Guardar cronograma"
        onSubmit={onSubmit}
        noBtns={editable ? !isEditing : false}
        size="full"
        btns={['reset', 'submit']}>
        <table className="table">
          <thead>
            <tr>
              <th>Titulo</th>
              <th></th>
              <th>Fecha Inicio</th>
              <th>Fecha Fin</th>
            </tr>
          </thead>
          <tbody>
            {cronogramaConfig.map((k) => (
              <CronogramaFila
                key={k.id}
                clear={clear}
                setClear={setClear}
                {...k}
                save={save}
                values={values}
                setValues={setValues}
              />
            ))}
          </tbody>
        </table>
      </Form>

      <SuccessErrorDlg
        success={success}
        error={error}
        onClose={() => {
          dispatch(cleanMsg());
          if (editable) {
            setIsEditing(false);
          }
        }}
      />
    </CommonRoot>
  );
};

export default TablaCronograma;
